import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { withRouter } from "next/router";
import { customerPlacedOrder, Products } from "../../config/queries";
import ajaxServices from "../../utils/ajaxServices";
import config from "../../config/index";
import labels from "../../config/labels";
import * as Analytics from "../../services/analyticsUtag";
import { breadcrumbGenerator } from "../../services/breadcrumbService";
import {
  dynamicBreadCrumb,
  showSpinner,
  hideSpinner,
  getCookieValue,
  getProductsCookie,
  isArrayNotEmpty,
  componentResize,
  formatBreadCrumb,
} from "../../utils/helperServices";
import BreadCrumb from "../../components/atoms/breadCrumb/BreadCrumb";
import ErrorTooltip from "../../components/molecules/errorToolTip/ErrorTooltip";
import OrderHistoryEmpty from "../../components/molecules/viewOrderHistory/orderHistoryEmpty/OrderHistoryEmpty";
import {
  Router,
  Container,
  CustomContainer,
  connect,
} from "../../components/atoms/DependencyHelper";
import { Logger } from "utils/logger";

const k8sConfig = typeof window === "undefined" ? require("config") : "";
const {
  default: OrderHistoryTop,
} = require("../../components/molecules/viewOrderHistory/orderHistoryTop/OrderHistoryTop");
const {
  default: OrderHistoryList,
} = require("../../components/molecules/viewOrderHistory/orderHistoryList/OrderHistoryList")

const ViewOrderHistory = ({
  userLoggedIn,
  profileData,
  profileLoading,
  paymentConfiguration,
  trackOrderEnabled,
  paymentOptionsEnabled,
  isMiniApp,
}) => {
  const env = config.env;
  const urlPrefix = config.envConfigs[env].shoppingUrlPrefix;
  const loginUrl = config.envConfigs[env].DIDLoginUrl;

  const dynamicRoute = dynamicBreadCrumb();
  const isMobile = componentResize();
  const [viewExecuted, setViewExecuted] = useState(false);
  const [analytics, setAnalytics] = useState(false);
  const [sortProductsBy, setSortProductsBy] = useState("");
  const [sortByYears, setSortByYears] = useState("");
  const [orderHistoryItems, setOrderHistoryItems] = useState([]);
  const [orderHistoryResponse, setOrderHistoryResponse] = useState(null);
  const [noSearchFound, setNoSearchFound] = useState(false);
  const [updatedCookieProduct, setUpdatedCookieProduct] = useState([]);
  const [viewData, setViewData] = useState({});
  const customerIdentifier =
    userLoggedIn && profileData?.profileID ? profileData?.profileID : "";
  const [userMetaData, setUserMetaData] = useState();
  const [searchOrderId, setSearchOrderId] = useState("");
  const [resetFilter, setResetFilter] = useState(false);
  const [serviceDown, setServiceDown] = useState(false);
  const section_lvls = {};

  const getSortQuery = (sortBy) => {
    switch (sortBy) {
      case labels.sortKeys.lbl_old_to_new:
        return "ASC";
      case labels.sortKeys.lbl_new_to_old:
      default:
        return "DESC";
    }
  };

  let parsedSku, skuArr;
  const productCookie = getCookieValue("products");
  if (productCookie) {
    parsedSku = JSON.parse(productCookie);
    skuArr = parsedSku.map((product) => product.sku);
  }

  useEffect(() => {
    if (profileLoading !== null && !profileLoading) {
      if (userLoggedIn) {
        Analytics.setAutoTagging(false);
        const tempuserMetaData = Analytics.getProfileData(
          userLoggedIn,
          profileData
        );
        setUserMetaData(tempuserMetaData);
        customerPlaceOrderCall();
      } else {
        let redirectURL = loginUrl + "?redirectUrl=" + window.location.href + (isMiniApp ? "&app=true" : "");
        window.location.replace(redirectURL);
      }
    }
  }, [userLoggedIn, profileLoading]);

  const sendErrorAnalytics = (error) => {
    Logger.error(error);
    Analytics.view({
      page_event: "view",
      page_channel: "shopping",
      page_name: "checkout: order history: no past orders",
      ...section_lvls,
      ...userMetaData,
    });
    setViewData({
      page_name: "checkout: order history: no past orders",
      ...section_lvls,
      ...userMetaData,
    });
  };

  const getOrderHistory = (params, loadMore, isSecondCall) => {
    showSpinner();
    ajaxServices
      .fetchGraphQLPOSTRequest(customerPlacedOrder, params)
      .then((result) => {
        const { customerPlacedOrder } = result || {};
        if (result && result.errors) {
          Analytics.link({
            page_name: "checkout: order history",
            page_form_event: "error",
            page_error_type: "page",
            page_errors: `[${
              result.errors[0] ? result.errors?.[0].message : ""
            }]`,
            page_errors_code: `oh-dxl-p-ohl-${result?.status}`,
          });
          setServiceDown(true);
        }

        if (customerPlacedOrder?.allOrderRecords) {
          setOrderHistoryResponse(customerPlacedOrder);
          let isMulti = false;
          if (loadMore) {
            const oldData = [...orderHistoryItems];
            const newData = customerPlacedOrder.allOrderRecords;
            newData.forEach((item) => {
              oldData.push(item);
            });
            setOrderHistoryItems(oldData);
          } else {
            setOrderHistoryItems(customerPlacedOrder.allOrderRecords);
          }
          const isMultipleOrder = customerPlacedOrder.allOrderRecords.filter(
            (item) => item?.order_type > 1
          );
          if (isMultipleOrder.length) {
            // TODO: Fix. not sure why "arr" was used.
            // eslint-disable-next-line no-undef
            isMulti = isMultipleOrder.some((v) => v !== arr[0]);
          }
          if (!isSecondCall) {
            Analytics.view({
              page_event: "view",
              page_name: "checkout: order history",
              page_channel: "shopping",
              multicart_flag: `${isMulti}`,
              ...section_lvls,
              ...userMetaData,
            });
          }
          setViewData({
            page_name: "checkout: order history",
            ...section_lvls,
            ...userMetaData,
          });
          setNoSearchFound(false);
        } else {
          setOrderHistoryItems(customerPlacedOrder.allOrderRecords);
          Analytics.view({
            page_event: "view",
            page_name: "checkout: order history: no past orders",
            page_channel: "shopping",
            page_site_section_lvl_1: `Order History`,
            page_site_section_lvl_2: `Home`,
            ...section_lvls,
            ...userMetaData,
          });
          setViewData({
            page_name: "checkout: order history: no past orders",
            page_site_section_lvl_1: `Order History`,
            page_site_section_lvl_2: `Home`,
            ...section_lvls,
            ...userMetaData,
          });
          if (searchOrderId && searchOrderId.length > 0 ) {
            setNoSearchFound(true);
          } else {
            setNoSearchFound(false);
          }
        }
        hideSpinner();
      })
      .catch((error) => {
        sendErrorAnalytics(error);
        hideSpinner();
      });
  };

  const getRecentProducts = () => {
    ajaxServices
      .fetchGraphQLPOSTRequest(Products, {
        ids: skuArr,
      })
      .then((product) => {
        if (product && product.errors) {
          Analytics.link({
            page_name: "checkout: order history",
            page_form_event: "error",
            page_error_type: "page",
            page_errors: `[${
              product.errors[0] ? product.errors?.[0].message : ""
            }]`,
            page_errors_code: `oh-dxl-p-p-${product.status}`,
          });
        }

        let productArr;
        if (
          product.products &&
          product.products.items &&
          isArrayNotEmpty(product.products.items)
        ) {
          productArr = product.products.items;
        }
        setUpdatedCookieProduct(productArr);
      })
      .catch((err) => {
        Analytics.link({
          page_name: "checkout: order history",
          page_form_event: "error",
          page_error_type: "page",
          page_errors: `[${
            err instanceof Error ? err.message : ""
          }]`,
          page_errors_code: `oh-dxl-p-p-${err?.status}`,
        });
      });
  };

  const customerPlaceOrderCall = async () => {
    showSpinner();
    try {
      const sortParam = getSortQuery(sortProductsBy);
      getOrderHistory(
        {
          order_id: searchOrderId,
          year: "",
          sort: sortParam,
          pageSize: labels.order_history_max_items_per_page,
          currentPage: 1,
        },
        false,
        false
      );

      getRecentProducts();

      if (Object.keys(dynamicRoute).length && !viewExecuted) {
        if (!analytics) {
          const breadcrumbs = Object.keys(dynamicRoute).reverse();
          let index = 0;
          for (let item of breadcrumbs) {
            index = index + 1;
            if (index > 4) break;
            section_lvls[`page_site_section_lvl_${index}`] = item;
          }
          setViewExecuted(true);
          setAnalytics(true);
        }
      }
    } catch (error) {
      sendErrorAnalytics(error);
      hideSpinner();
    }
  };

  const productItems = getProductsCookie(parsedSku, updatedCookieProduct);

  const sortBy = (val) => {
    if (noSearchFound) {
      setSearchOrderId("");
      setNoSearchFound(false);
    }
    setSortProductsBy(val);
    const sortParam = getSortQuery(val);
    getOrderHistory(
      {
        order_id: searchOrderId,
        year: sortByYears,
        sort: sortParam,
        pageSize: labels.order_history_max_items_per_page,
        currentPage: 1,
      },
      false,
      true
    );

    Analytics.link({
      ...viewData,
      link_type: "o",
      page_tool_event: "use",
      page_tool_name: "checkout: order history: filter",
      filter_query: `${sortByYears ? sortByYears : labels.lbl_all_years}, ${
        val ? val : labels.sortKeys.lbl_new_to_old
      }`,
    });
  };

  const sortByYear = (val) => {
    if (noSearchFound) {
      setSearchOrderId("");
      setNoSearchFound(false);
    }
    const sortByYearsVal = val === labels.lbl_all_years ? "" : val;
    setSortByYears(sortByYearsVal);
    const sortParam = getSortQuery(sortProductsBy);
    getOrderHistory(
      {
        order_id: searchOrderId,
        year: sortByYearsVal,
        sort: sortParam,
        pageSize: labels.order_history_max_items_per_page,
        currentPage: 1,
      },
      false,
      true
    );

    Analytics.link({
      ...viewData,
      link_type: "o",
      page_tool_event: "use",
      page_tool_name: "checkout: order history: filter",
      filter_query: `${val ? val : labels.lbl_all_years}, ${
        sortProductsBy ? sortProductsBy : labels.sortKeys.lbl_new_to_old
      }`,
    });
  };

  const updateCurrentPage = (pageNumber) => {
    const sortParam = getSortQuery(sortProductsBy);
    getOrderHistory(
      {
        order_id: "",
        year: sortByYears,
        sort: sortParam,
        pageSize: labels.order_history_max_items_per_page,
        currentPage: pageNumber,
      },
      true,
      true
    );
  };

  const handleChange = (e) => {
    setSearchOrderId(e.target.value);
  };

  const handleSearchByOrderId = (filterByOrderId) => {
    Analytics.link({
      ...viewData,
      search_event: "search",
      search_terms: `[${searchOrderId}]`,
      search_category: "order search",
      search_type: "order search",
      page_tool_event: "use",
      page_tool_name: "shopping: order history: search orders",
    });
    setResetFilter(true);
    setNoSearchFound(false);

    const sortParam = getSortQuery(sortProductsBy);
    getOrderHistory(
      {
        order_id: filterByOrderId,
        year: "",
        sort: sortParam,
        pageSize: labels.order_history_max_items_per_page,
        currentPage: 1,
      },
      false,
      true
    );
  };

  const goToProducts = async () => {
    showSpinner();
    await Router.push(`${urlPrefix}/products`);
    window.scrollTo(0, 0);
    hideSpinner();
    Analytics.link({
      ...viewData,
      link_type: "o",
      link_name: "checkout: order history: start shopping",
      link_url: "/products",
    });
  };

  const renderEmptyBox = () => {
    return (
      <OrderHistoryEmpty
        productItems={productItems}
        goToProducts={goToProducts}
      />
    );
  };

  return (
    <CustomContainer>
      <Container>
        <CustomContainer className="br-left">
          <BreadCrumb
            list={formatBreadCrumb(breadcrumbGenerator().orderhistory)}
          />
        </CustomContainer>
      </Container>
      <OrderHistoryTop
        itemsLoaded={orderHistoryItems?.length}
        totalItemsCount={orderHistoryResponse?.total_count}
        sortBy={sortBy}
        sortByYear={sortByYear}
        noSearchFound={noSearchFound}
        handleSearchByOrderId={handleSearchByOrderId}
        pageInfo={orderHistoryResponse?.page_info}
        customTabletSearchClass="custom-tablet-search"
        searchOrderId={searchOrderId}
        handleChange={handleChange}
        resetFilter={resetFilter}
      />
      {serviceDown && (
        <Container>
          <ErrorTooltip
            type="orders_service"
            errorMsg={labels.lbl_orders_service_down}
            className="mb-7"
            hideDismissButton={true}
          />
        </Container>
      )}
      {orderHistoryItems?.length > 0 ? (
        <OrderHistoryList
          dataList={orderHistoryItems}
          pageInfo={orderHistoryResponse?.page_info}
          totalItemsCount={orderHistoryResponse?.total_count}
          customerIdentifier={customerIdentifier}
          isMobile={isMobile}
          updateCurrentPage={updateCurrentPage}
          paymentConfiguration={paymentConfiguration}
          trackOrderEnabled={trackOrderEnabled}
          paymentOptionsEnabled={paymentOptionsEnabled}
        />
      ) : (
        !serviceDown && renderEmptyBox()
      )}
    </CustomContainer>
  );
};

export const getServerSideProps = async () => {
  let paymentDetails = config.paymentConfig;
  paymentDetails.payServerUser = k8sConfig.get("payment.payserveruser");
  paymentDetails.paymentGatewayBaseUrl = k8sConfig.get(
    "payment.paymentgatewaybaseurl"
  );
  paymentDetails.paymentGatewayUrl = k8sConfig.get("payment.paymentgatewayurl");
  paymentDetails.transactionStatusCallbackFormat = k8sConfig.get(
    "payment.transactionstatuscallbackformat"
  );
  paymentDetails.transactionStatusCallbackMethod = k8sConfig.get(
    "payment.transactionstatuscallbackmethod"
  );
  paymentDetails.transactionStatusCallbackUrl = k8sConfig.get(
    "payment.transactionstatuscallbackurl"
  );
  paymentDetails.currency = k8sConfig.get("payment.currency");
  paymentDetails.transactionType = k8sConfig.get("payment.transactiontype");
  paymentDetails.merchantIdentifier = k8sConfig.get(
    "payment.merchantidentifier"
  );
  paymentDetails.encType = k8sConfig.get("payment.enctype");
  const trackOrderEnabled = k8sConfig.get("features.trackOrder");
  const paymentOptionsEnabled = k8sConfig.get("features.paymentOptions");

  return {
    props: {
      paymentConfiguration: paymentDetails,
      trackOrderEnabled: trackOrderEnabled === "true",
      paymentOptionsEnabled: paymentOptionsEnabled === "true",
    },
  };
};

const mapStateToProps = (state) => ({
  userLoggedIn: state.navDetails.isUserLoggedIn,
  profileData: state.navDetails.profileData,
  profileLoading: state.navDetails.isProfileLoading,
  isMiniApp: state.navDetails.isMiniApp,
});

ViewOrderHistory.propTypes = {
  userLoggedIn: PropTypes.bool,
  profileData: PropTypes.any,
  profileLoading: PropTypes.any,
  paymentConfiguration: PropTypes.any,
  trackOrderEnabled: PropTypes.bool,
  paymentOptionsEnabled: PropTypes.bool,
  isMiniApp: PropTypes.bool,
};

export default connect(mapStateToProps)(withRouter(ViewOrderHistory));
